"use client";

import { LISTING_API } from "@/lib/constants";
import CategoryCard from "@/modules/categories-listings/components/categories-listing-card";
import { TCategoryData } from "@/services/category";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";

async function getListingData() {
	const url = new URL(`${LISTING_API}`);
	const res = await fetch(url);

	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}

	const { data } = (await res.json()) as { data: TCategoryData[] };

	return data;
}

const Categories = () => {
	const {
		isLoading,
		isError,
		data: categories = [],
	} = useQuery({ queryKey: ["categories"], queryFn: getListingData });

	if (isError) {
		return <span>Something went wrong while fetching families</span>;
	}

	return isLoading ? (
		<div className="flex flex-col gap-8">
			<Skeleton count={1} height={256} className="flex-1" />
			<Skeleton count={1} height={256} className="flex-1" />
			<Skeleton count={1} height={256} className="flex-1" />
		</div>
	) : (
		<div className="flex flex-wrap gap-6">
			{categories?.map((listing: TCategoryData) => (
				<CategoryCard
					key={listing.id}
					name={listing.title}
					icon={listing.logoUrl}
					description={listing.description}
					slug={listing.slug || ""}
					numberOfProducts={listing.productsCount}
					ambassadors={listing.ambassadors}
					productLogos={listing.productLogos || []}
				/>
			))}
		</div>
	);
};

export default Categories;
